import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  LAValidators,
  matchValidator,
} from '@lockton-apps/shared/util/form-utils';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';
import { defaults, forEach, get, isEmpty, replace } from 'lodash';

interface PasswordFieldProps extends FormlyFieldProps {
  withHelper: boolean;
}

@Component({
    selector: 'lockton-apps-password-field-type',
    templateUrl: './password-field-type.component.html',
    styleUrls: ['./password-field-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PasswordFieldTypeComponent extends FieldType<
  FieldTypeConfig<PasswordFieldProps>
> {}
